import React, {useState} from 'react';
import RadioButton from "../RadioButton";
import { Trans, useLingui } from '@lingui/react/macro';
import { navigate } from '../../utils/navigationUtils';

function ExistingCC(props) {
    const [answer, setAnswer] = useState(null);
    const {t, i18n} = useLingui();

    const last4Digits = props.cardInfo.cardNumber.substr(-4);
    const infoText = props.cardInfo.isCardOwner
        ? i18n._({ id: "cardOwner.self", message:`You already have a card assigned to you ending in {last4Digits}.`, values: { last4Digits } })
        : i18n._({ id: "cardOwner.other", message:`{cardOwner} has already assigned their card to you.`, values: { cardOwner: props.cardInfo.cardOwner } })

    const onSubmit = () => {
        if(answer === null) {
            return;
        }

        if(answer === false) {
            const url = t({id: "/precruise/passengers"}) + "/cc";
            navigate(url);
        }
        else {
            props.replaceCard();
        }
    }

    return (
        <div>
            <div className="mt-6 text-lg">
                <p>
                    {infoText}
                </p>
                <p className="mt-4">
                    <Trans id="do_you_want_another_cc">Do you want to add a different card, to replace it?</Trans>
                </p>

            </div>
            <div>
                <div className="mt-4">
                    <RadioButton
                        label={t({id: "Yes"})}
                        _onChange={() => setAnswer(true)}
                        isSelected={answer === true}
                    />
                </div>

                <div className="mt-4">
                    <RadioButton
                        label={t({id: "no"})}
                        _onChange={() => setAnswer(false)}
                        isSelected={answer === false}
                    />
                </div>
            </div>
            <div className="mt-6 mb-8 xl:mb-12">
                <button className={`action-button w-mobile ${answer !== null ? "action-button-enabled" : "action-button-disabled"}`}
                        onClick={onSubmit}>
                    <Trans id="next">Next</Trans>
                </button>
            </div>
        </div>
    )
}

export default ExistingCC;